(function($){



	if ( typeof side_fields !== 'undefined' ) {


		window.SIDEBARPRODUCT = {

			lastScrollTop : 0,
			position_id : 0,
			ranges : [0],

			footer_top : $('#footer').offset().top,
			sidebar_height : $('.cat-right-zone').outerHeight(true),
			sidebar_top_absolute : this.footer_top - this.sidebar_height,


			menu_active: false,
			menu_filter: {
				await: function () {

					window.SIDEBARPRODUCT.$menu_item = $('.filter-menu-item-link');

					window.SIDEBARPRODUCT.menu_active = false;

					// lors du click des items du menu
					window.SIDEBARPRODUCT.$menu_item.on('click', function (e) {
						e.preventDefault();
						let el = $(e.currentTarget);
						let id = el.attr('data-id');

						window.SIDEBARPRODUCT.menu_filter.change_item_selected(el);
						window.SIDEBARPRODUCT.menu_filter.show_element_selected(id);

					}.bind(this));
				},
				show_element_selected: function (id) {
					if (id == "all") { // show all element
						$('#category-section > div').removeClass('active');
						$('#category-section > div').removeClass('inactive');
						window.SIDEBARPRODUCT.set_side_html(side_fields[0].image, side_fields[0].text, side_fields[0].text_position, side_fields[0].image_mobile, side_fields[0].copyright);
						window.SIDEBARPRODUCT.menu_active = false;
					} else {
						if ($('#' + id).length) { // si section existe
							$('#category-section > div').removeClass('active').addClass('inactive');
							$('#' + id).addClass('active');
							window.SIDEBARPRODUCT.menu_active = true;
							$(side_fields).each(function (i, e) {
								if (e.id === id) {
									window.SIDEBARPRODUCT.set_side_html(e.image, e.text, e.text_position, e.image_mobile, e.copyright);
								}
							});

						}
					}
				},
				change_item_selected: function (e) {
					window.SIDEBARPRODUCT.$menu_item.removeClass('active');
					$(e).addClass('active');
				},
				set_menu_with_id: function (id) {
					// sections html
					$('#category-section > div').removeClass('active').addClass('inactive');
					$('#' + id).addClass('active');

					window.SIDEBARPRODUCT.menu_active = true;
					// reset des menu actifs
					$('.filter-menu-item-link').removeClass('active');
					// ajout active dans le bon élément
					$('a[data-id="' + id + '"]').addClass('active');

					$(side_fields).each(function (i, e) {
						if (e.id === id) {
							window.SIDEBARPRODUCT.set_side_html(e.image, e.text, e.text_position, e.image_mobile, e.copyright);
						}
					});
				}
			},


			get_sections_ranges : function  () {

				$(side_fields).each(function (i,e) {
					if ( i > 0 ){ // pas le premier, car id (all)
						let object = {};

						if ( $('#' + e.id) ){
							object.id = e.id;
							object.top = $('#' + e.id).offset().top;
							object.bottom = object.top + $('#' + e.id).outerHeight(true);

							window.SIDEBARPRODUCT.ranges.push(object);
						}
					}
				});
			},
			get_page_top : function (){
				return $(document).scrollTop();
			},
			set_side_html : function ($image_url, $html, $text_position, $image_mobile, $copyright){
			//console.log("set_side_html : function ("+$image_url+","+ $html+", "+$text_position+","+ $image_mobile+", "+$copyright+")");
				//$('.cat-right-zone').css('background-image','url('+ $image_url +')')

				$('.header-bg-mobile').addClass('hide');

				var header_img = $image_mobile !== undefined ? $image_mobile : $image_url;

				setTimeout(function (){
					//var url = $image_url.attr('src');
					//$('.header-bg-mobile').css('background-image', 'url(' + header + ')');
					$('.header-bg-mobile').find('img').remove();
					$('.header-bg-mobile').append(header_img);
					$('.description-mobile').html($html);
					//$('.header-bg-mobile').css('background-image', 'url(' + header + ')');

					$('.header-bg-mobile').removeClass('hide');
				},250);

				$('.side-content').show();
				setTimeout(function(){
					$('.side-content').attr('id', $text_position);
					$('.side-content .side-content-text').html($html);
					$('.copyright-zone').html($copyright);

					//$('.side-img').attr('src', $image_url);
					$('.side-img').remove();
					$('.cat-right-zone').prepend($image_url);

					$('.side-img').on('load', function(){
						$(this).fadeIn();
						//$('.side-content').show();
						setTimeout(function(){
							$('.side-img-clone').attr('src', $('.side-img-clone').parents('.cat-right-zone').find('.side-img').attr('src'));
						}, 500);
					});
				}, 350);
			},
			reset_triggers : function () {
				$(side_fields).each(function (i,e) {
					e.trigger = false;
				});
			},
			trigger_field : function  (id){
				window.SIDEBARPRODUCT.reset_triggers();
				side_fields[id].trigger = true;
			}


		};







		$(document).ready(function () {

			//console.log({footer_top,sidebar_height,sidebar_top_absolute});

			let semi_windows_height = $(window).outerHeight(true) / 2;

			window.SIDEBARPRODUCT.get_sections_ranges();

			$( window.SIDEBARPRODUCT.ranges ).each( function ( i, e ) {
				if ( window.SIDEBARPRODUCT.get_page_top() > e.top - semi_windows_height && window.SIDEBARPRODUCT.get_page_top() < e.bottom - semi_windows_height ) {
					window.SIDEBARPRODUCT.position_id = i;
				}
			});
			$('.side-content').hide();
			$('.side-img').fadeOut();
			window.SIDEBARPRODUCT.set_side_html( side_fields[window.SIDEBARPRODUCT.position_id].image, side_fields[window.SIDEBARPRODUCT.position_id].text, side_fields[window.SIDEBARPRODUCT.position_id].text_position, side_fields[window.SIDEBARPRODUCT.position_id].image_mobile, side_fields[window.SIDEBARPRODUCT.position_id].copyright );
			window.SIDEBARPRODUCT.trigger_field(window.SIDEBARPRODUCT.position_id);

		});
		$(window).scroll(function(event){

			let semi_windows_height = $(window).outerHeight(true) / 2;

			window.SIDEBARPRODUCT.footer_top = $('#footer').offset().top;
			window.SIDEBARPRODUCT.sidebar_height = $('.cat-right-zone').outerHeight(true);
			window.SIDEBARPRODUCT.sidebar_top_absolute = window.SIDEBARPRODUCT.footer_top - window.SIDEBARPRODUCT.sidebar_height;

			// sidebar stop fixed si on arrive au footer
			if ( (window.SIDEBARPRODUCT.get_page_top() + $(window).outerHeight(true)) >= window.SIDEBARPRODUCT.footer_top  ){
				$('.cat-right-zone').css({
					position: 'absolute',
					top: window.SIDEBARPRODUCT.sidebar_top_absolute,
				});
			} else {
				$('.cat-right-zone').css({
					position: 'fixed',
					top: 0,
				});
			}


			let st = $(this).scrollTop();

			if ( window.SIDEBARPRODUCT.menu_active === false ) {
				if (st > window.SIDEBARPRODUCT.lastScrollTop){
					// downscroll code
					if ( window.SIDEBARPRODUCT.position_id !== (window.SIDEBARPRODUCT.ranges.length -1) ){
						if ( window.SIDEBARPRODUCT.get_page_top() >= window.SIDEBARPRODUCT.ranges[(window.SIDEBARPRODUCT.position_id + 1)].top - semi_windows_height ){
							if ( side_fields[(window.SIDEBARPRODUCT.position_id + 1)].trigger === false ){
								window.SIDEBARPRODUCT.position_id+=1;
								window.SIDEBARPRODUCT.trigger_field(window.SIDEBARPRODUCT.position_id);
								$('.side-content').hide();
								$('.side-img').fadeOut();
								window.SIDEBARPRODUCT.set_side_html(side_fields[window.SIDEBARPRODUCT.position_id].image, side_fields[window.SIDEBARPRODUCT.position_id].text, side_fields[window.SIDEBARPRODUCT.position_id].text_position, side_fields[window.SIDEBARPRODUCT.position_id].image_mobile, side_fields[window.SIDEBARPRODUCT.position_id].copyright );
							}
						}
					}
				} else {
					// upscroll code
					if ( window.SIDEBARPRODUCT.position_id !== 0 ){
						if ( window.SIDEBARPRODUCT.get_page_top() <= window.SIDEBARPRODUCT.ranges[(window.SIDEBARPRODUCT.position_id-1)].bottom - semi_windows_height && window.SIDEBARPRODUCT.get_page_top() >= window.SIDEBARPRODUCT.ranges[(window.SIDEBARPRODUCT.position_id-1)].top - semi_windows_height  ){
							if ( side_fields[(window.SIDEBARPRODUCT.position_id - 1)].trigger === false ){
								window.SIDEBARPRODUCT.position_id-=1;
								window.SIDEBARPRODUCT.trigger_field(window.SIDEBARPRODUCT.position_id);
								$('.side-content').hide();
								$('.side-img').fadeOut();
								window.SIDEBARPRODUCT.set_side_html(side_fields[window.SIDEBARPRODUCT.position_id].image, side_fields[window.SIDEBARPRODUCT.position_id].text, side_fields[window.SIDEBARPRODUCT.position_id].text_position, side_fields[window.SIDEBARPRODUCT.position_id].image_mobile, side_fields[window.SIDEBARPRODUCT.position_id].copyright);
							}
						} else if ( window.SIDEBARPRODUCT.get_page_top() < window.SIDEBARPRODUCT.ranges[1].top - semi_windows_height ){
							window.SIDEBARPRODUCT.position_id-=1;
							window.SIDEBARPRODUCT.trigger_field(window.SIDEBARPRODUCT.position_id);
							$('.side-content').hide();
							$('.side-img').fadeOut();
							window.SIDEBARPRODUCT.set_side_html(side_fields[window.SIDEBARPRODUCT.position_id].image, side_fields[window.SIDEBARPRODUCT.position_id].text, side_fields[window.SIDEBARPRODUCT.position_id].text_position, side_fields[window.SIDEBARPRODUCT.position_id].image_mobile, side_fields[window.SIDEBARPRODUCT.position_id].copyright);
						}
					}
				}
			}

			window.SIDEBARPRODUCT.lastScrollTop = st;
		});


		if ( $('#category-section').length ){
			window.SIDEBARPRODUCT.menu_filter.await();
		}


		if ( typeof filter !== 'undefined' ){
			//window.SIDEBARPRODUCT.menu_filter.show_element_selected(filter);
			$(document).ready(function (e){
				window.SIDEBARPRODUCT.menu_filter.set_menu_with_id(filter);
			})
		}



	}








})(jQuery);